import React, { useState, useEffect } from 'react';

import { Globals, getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildPrimaryContact } from "root/DataFunctions/ChildDataFns";

import ModalContentWrapper from '../ModalContentWrapper';

const ModalViewChildContact = (props) =>
{
    const [contactDetails, setContactDetails] = useState("");

    const userImageUrl = contactDetails && '/getFile.php?enc_docid=' + contactDetails.document_id ;

    useEffect(() => {
        getChildPrimaryContact(response =>
        {
            setContactDetails(getDataFromResponse(response)[0]);
        });
    }, []);
    return (
        <div className="child-contact-modal">
            <ModalContentWrapper className="modal-wrapper ">
                <h2> Your contact is</h2>
                <div className="child-contact">
                    <div className="child-contact-profile">
                        <div className="child-contact-profile-image">
                            <img width='200px' src={userImageUrl} alt="User Image" />
                        </div>
                    </div>
                    <div className="child-contact-info">
                        <div>
                            <h3>Name:</h3>
                            {contactDetails && <p>{contactDetails.firstname} {contactDetails.surname}</p>}
                        </div>
                        <div>
                            <h3>Telephone:</h3>
                            <p>{contactDetails && contactDetails.telno}</p>
                        </div>
                        <div>
                            <h3>Email:</h3>
                            <p>{contactDetails && contactDetails.email}</p>
                        </div>
                    </div>
                </div>
            </ModalContentWrapper>
        </div>
    )
}

export default ModalViewChildContact;
